import { createSelector } from 'reselect';
import { List, Map, Set } from 'immutable';

export const getDeviceGroupState = (state) =>
  state.groups;

export const getRootState = (state) =>
  state;

export const getDeviceGroups = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    const allData = deviceGroup?.getIn(['groups', 'data'], Map());
    const pageIds = deviceGroup?.getIn(['groups', 'records'], List());
    let pageData = List();
    pageIds.map((id) => {
      const data = allData.getIn([id, 'record']);
      if (data) {
        pageData = pageData.push(data);
      }
    });
    return pageData;
  }
);

export const getExpandingDeviceGroups = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    return deviceGroup.getIn(['groups', 'expandingDevices'], Set());
  }
);

export const getLoadingDeviceGroups = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    return deviceGroup.getIn(['groups', 'loading'], false);
  }
);

export const getNumDeviceGroupsPages = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    return deviceGroup.getIn(['groups', 'totalPages'], 0);
  }
);

export const getTotalDeviceGroups = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    return deviceGroup.getIn(['groups', 'total'], 0);
  }
);

export const getDeviceGroupsLabels = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    const data = deviceGroup.getIn(['groups', 'data']);
    let result = List();
    data.forEach((value) => {
      const id = value?.record.get('id');
      const name = value?.record.get('group_name');
      result = result.push(Map({ id, name }));
    });
    return result;
  }
);

export const getEditingDeviceGroupLoading = createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    return deviceGroup.getIn(['editing', 'loading'], false);
  }
);

// Only answers for the group actually loaded into the edit slot, so a record left over from a
// previously edited group cannot be mistaken for this one.
export const getEditingDeviceGroup = (id) =>  createSelector(
  [getDeviceGroupState],
  (deviceGroup) => {
    if (!id || deviceGroup.getIn(['editing', 'id']) !== id) {
      return Map();
    }
    return deviceGroup.getIn(['editing', 'record'], Map());
  }
);
